
import { defineComponent, computed } from "vue";
import stateStore from "../../utils/store";
import store from "@/store";
export default defineComponent({
  name: "MainSidebar",
  setup() {
    const stateStoreInstance = stateStore;
    const curUserPayload = computed(() => store.getters[`auth/curUserObject`]);
    const menu = computed(() => store.getters[`auth/menu`]);
    const paths = computed(() => store.getters[`auth/paths`]);
    return {
      curUserPayload,
      menu,
      paths,
      stateStoreInstance,
    };
  },

  methods: {
    getRouter(menu: any): any {
      const result = this.paths.filter((f: any) => f.MenuId === menu.Id);
      return result;
    },
    logout() {
      store.dispatch("auth/logout");
    },
  },
});
